<template>
    <div class=" pa-2">
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>
        <v-row>
            <v-col cols="12">
                <v-card outlined elevation="2">
                    <v-card-title>
                        <span>Elija un nivel: </span>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="space-around">
                            <v-col v-for="nivel of NivelesAdmin" :key="nivel.id" xs="12" sm="4" md="4" lg="3">
                                <TarjetaSencilla :title="nivel.desc_nivel" :bgColor="nivel.color" className="w-100">
                                    <TableButtonComp v-if="componenteEvento.visualizar_submodulo"
                                        @click="getAllGradosAdmin(nivel)" iconBut="fa-eye" textButton="Ver grados" />

                                </TarjetaSencilla>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-chip label v-if="GradosAdmin != 0" :color="titulo_nivel.color" class="white--text">
                            <h3>Nivel: {{ titulo_nivel.desc_nivel }}</h3>
                        </v-chip>
                    </v-card-title>
                    <v-card-text>
                        <ComundataTablecomp :whitSearch="true" :headers="SeccionHeaders" :items="GradosAdmin"
                            :search="search" class="" noResultsText="Seleccione un nivel con datos"
                            placeholderTextsearch="Buscar">

                            <template v-slot:agregar="{ item }">
                                <TableButtonComp verButton v-if="componenteEvento.visualizar_submodulo"
                                    @click="verSecciones(item)" tooltipText="Ver secciones" />
                            </template>
                        </ComundataTablecomp>
                    </v-card-text>
                </v-card>

            </v-col>
        </v-row>

        <ComunDialogComp v-model="modal_secciones" maxWidth="1200" @close-modal="modal_secciones = false">
            <template v-slot:title>
                Secciones de
                <v-chip label :color="titulo_nivel.color" class="ml-2 white--text">
                    <h3>{{ titulo_nivel.desc_nivel }} - {{ itemGrado.desc_grado }} </h3>
                </v-chip>
            </template>
            <template v-slot:body>
                <v-row v-if="componenteEvento.agregar_submodulo">
                    <v-col class="d-flex flex-row-reverse ">
                        <TableButtonComp @click="crearSecciones(itemGrado)" textButton="Crear sección" iconBut="fas fa-plus"
                            normalButton />
                    </v-col>
                </v-row>

                <v-col cols="12">
                    <ComundataTablecomp :headers="SeccionesHeaders" :items="SeccionGrado"
                        noResultsText="Aún no has agregado secciones al grado" :search="search2">
                        <template v-slot:agregar="{ item }">
                            <div class="d-flex gap-10">
                                <TableButtonComp v-if="componenteEvento.visualizar_submodulo"
                                    @click="verAlumnosSeccion(item)" verButton tooltipText="Ver estudiantes" />
                                <TableButtonComp addButton v-if="componenteEvento.agregar_submodulo"
                                    @click="getAllAlumnos(item)" tooltipText="Agregar estudiante" />
                                <TableButtonComp editButton v-if="componenteEvento.agregar_submodulo"
                                    @click="editedItem(item)" tooltipText="Editar sección" />
                                <TableButtonComp delete-button tooltip-text="Eliminar sección"
                                    @click="OndeleteSeccionItem(item)" />
                            </div>

                        </template>
                    </ComundataTablecomp>
                </v-col>


            </template>
        </ComunDialogComp>

        <!---- fin modal  secciones ----->

        <!------modal crear seccion------>
        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="modal_seccion" maxWidth="400px" @close-modal="modal_seccion = false">
                <template v-slot:title>
                    {{ formAccion }} sección
                </template>
                <template v-slot:body>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedSeccion.nombre_seccion" label="Nombre"
                            :rules="validationRules.validateCampo"></v-text-field>
                        </v-col>
                        <!-- @keyup="setAbreviatura" -->
                        <v-col cols="12" sm="12" md="12">
                            <textfieldComp textLabel="Abreviatura" v-model="editedSeccion.abreviatura_seccion" 
                                :rules="validationRules.validateSeccionAbr" />
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <AutocompleteComp v-model="editedSeccion.id_turno" :items="Turnos" item-value="id"
                                item-text="desc_turno" textLabel="Turno" :rules="validationRules.validateCampo" />

                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Capacidad mínima" type="number" v-model="editedSeccion.min_capacidad"
                                :rules="[rul.required]" min="0"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Capacidad máxima" type="number" v-model="editedSeccion.max_capacidad"
                                :rules="[rul.required]" min="0"></v-text-field>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:actions>
                    <!-- boton guardar -->
                    <v-spacer />
                    <!-- <v-btn class="btn_style3" dark @click="modal_seccion = false">Cancelar</v-btn> -->
                    <TableButtonComp @click="updateSeccion(editedSeccion.id)" v-if="editarSec" textButton="Guardar cambios"
                        iconBut="fas fa-save" normalButton />
                    <!-- <v-btn class="btn_block_style2" dark @click="updateSeccion(editedSeccion.id)" v-if="editarSec">
                        GUARDAR CAMBIOS </v-btn> -->
                    <TableButtonComp @click="addSeccion" v-if="crearSec" textButton="Guardar" iconBut=" fas fa-save"
                        normalButton />
                    <!-- <v-btn class="btn_block_style2" dark @click="addSeccion" v-if="crearSec">Guardar</v-btn> -->
                    <TableButtonComp classColor="red" classButton="ml-2" normalButton @click="modal_seccion = false"
                        textButton="Cancelar" />
                </template>
            </ComunDialogComp>

        </v-form>
        <!---- fin modal crear secciones ----->


        <!------modal ver alumnos de la seccion------>
        <ComunDialogComp v-model="modal_seccion_alumnos" maxWidth="1200" @close-modal="modal_seccion_alumnos = false">
            <template v-slot:title>
                Estudiantes de
                <v-chip label :color="titulo_nivel.color" class="ml-2 white--text">
                    <h3>{{ titulo_nivel.desc_nivel }} - {{ itemGrado.desc_grado }} </h3>
                </v-chip>
            </template>
            <template v-slot:body>
                <ComundataTablecomp whitSearch :headers="salonHeaders" :items="SeccionAlumnos" :search="search3"
                    noResultsText="Aún no has agregado a ningún estudiante a la sección">
                    <template v-slot:nom_alumno="{ item }">
                        <span class="text-nombre">{{ item.ape1_persona }} {{ item.ape2_persona }}
                            {{ item.nombre_persona }}</span>
                    </template>

                    <template v-slot:sexo="{ item }">

                        <v-chip :class="item.sexo_persona === 'F' ? 'pink lighten-1' : 'blue darken-1'" dark small>
                            {{ item.sexo_persona === 'F' ? ' Femenino' : 'Masculino' }}
                            <v-icon class="ml-1" small>
                                {{ item.sexo_persona === 'F' ? ' fa-female' : 'fa-male' }}
                                fa-female</v-icon>
                        </v-chip>

                    </template>

                    <template v-slot:action_eliminar="{ item }">
                        <TableButtonComp v-if="componenteEvento.editar_submodulo" deleteButton @click="OndeleteItem(item)"
                            tooltipText="Eliminar estudiante" />

                    </template>
                </ComundataTablecomp>
            </template>

        </ComunDialogComp>





        <!--------modal alumnos ------>
        <ComunDialogComp v-model="modal_alumnos" maxWidth="1200" @close-modal="modal_alumnos = false">
            <template v-slot:title>
                Agregar estudiante a
                <v-chip :color="titulo_nivel.color" class="ml-2 white--text" label>
                    <h3>{{ titulo_nivel.desc_nivel }} - {{ itemGrado.desc_grado }} </h3>
                </v-chip>
            </template>
            <template v-slot:body>
                <ComundataTablecomp whitSelect whitSearch v-model="alumnosSeleccionados" :headers="tablaAlumnosHeaders"
                    :items="Alumnos" :search="search_alumnos" noResultsText="Sin estudiantes">
                    <template v-slot:nom_alumno="{ item }">
                        <span class="text-nombre">{{ item.ape1_persona }} {{ item.ape2_persona }}
                            {{ item.nombre_persona }}</span>
                    </template>

                    <template v-slot:sexo="{ item }">
                        <v-chip :class="item.sexo_persona === 'F' ? 'pink lighten-1' : 'blue darken-1'" dark>
                            {{ item.sexo_persona === 'F' ? 'Femenino ' : 'Masculino' }}
                            <v-icon class="ml-1" small>
                                {{ item.sexo_persona === 'F' ? 'fa-female' : 'fa-male' }}
                            </v-icon>
                        </v-chip>

                    </template>
                </ComundataTablecomp>


            </template>

            <template v-slot:actions>
                <v-spacer />
                <TableButtonComp normalButton iconBut="fas fa-plus" :disabled="alumnosSeleccionados.length === 0"
                    @click="modal_confirm = true" textButton="Agregar" />
                <TableButtonComp classColor="red" classButton="ml-2" normalButton @click="modal_alumnos = false"
                    textButton="Cancelar" />

            </template>

        </ComunDialogComp>

        <!---- fin modal  alumnos ----->






        <!-- modal agregar alumnos --->
        <ComunDialogComp v-model="modal_confirm" maxWidth="450" title="Confirmar">
            <template v-slot:body>
                <h4>¿Está seguro de agregar el/los estudiante(s) seleccionado(s) a la sección?</h4>

            </template>
            <template v-slot:actions>
                <v-spacer></v-spacer>
                <TableButtonComp normalButton classColor="red" classButton="mr-2" @click="modal_confirm = false"
                    textButton="Cancelar" />
                <TableButtonComp normalButton @click="addAlumnosSeccion" textButton="Confirmar" iconBut="fa fa-check" />

            </template>

        </ComunDialogComp>

        <!--------fin modal-->
        <!-- modal de eliminar un alumno de una seccion -->
        <confirm v-if="confirm.title == '¿Está seguro de eliminar este registro?'" @cancelar="clear_confirm" @aceptar="deleteItem" titleWindow="Eliminar estudiante" :title="confirm.title"
            :active="confirm.active" />

        <!-- modal de eliminar una seccion -->
        <confirm v-if="confirm.title == '¿Está seguro de eliminar esta sección?'" @cancelar="clear_confirm" @aceptar="deleteSeccionItem" titleWindow="Eliminar sección"
            :title="confirm.title" :active="confirm.active" />

    </div>
</template>

<script>
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import TarjetaSencilla from "@/components/ComponentsEst/TarjetaSencilla.vue"

import ComundataTablecomp from "@/components/ComponentsEst/ComundataTablecomp.vue"
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import { SeccionHeaders, SeccionesHeaders, salonHeaders, tablaAlumnosHeaders } from "../../helpers/headersTable";
import { validationRules } from "../../helpers/validatorHelpers";
import ComunDialogComp from "../../components/ComponentsEst/ComunDialogComp.vue";
import textfieldComp from "../../components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";


export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { TarjetaSencilla, BtnComp, ComundataTablecomp, TableButtonComp, ComunDialogComp, textfieldComp, AutocompleteComp },
    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 38, "id_modulo": 6 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        confirm: {
            item: {},
            title: "",
            active: false,
        },

        //validaciones de formulario

        rul: {
            required: value => !!value || 'Campo requerido',
            inputReq: value => !!value || 'Campo requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },
        },

        // consulta principal
        SeccionHeaders,
        SeccionesHeaders,
        salonHeaders,
        tablaAlumnosHeaders,
        NivelesAdmin: [],

        search: "",

        GradosAdmin: [],
        titulo_nivel: [],

        /////////////////////////////
        // modal secciones
        modal_secciones: false,
        itemGrado: {
            id: 0
        },
        mostrarMensaje: false,
        search2: "",
        SeccionGrado: [],

        /////////////////////////////////



        // modal crear seccion
        modal_seccion: false,
        Turnos: [],
        editedSeccion: [],
        editando: -1,
        editarSec: true,
        crearSec: true,
        ////////////////////////////



        //modal ver alumnos
        modal_seccion_alumnos: false,
        SeccionAlumnos: [],
        mostrarMensaje2: false,

        search3: "",

        ///////////////////////////



        // modal agregar alumnos
        modal_alumnos: false,
        Alumnos: [],

        search_alumnos: '',
        tabla_alumnos: [
            /* { text: "#", align: "left", sortable: false, value: "id_persona" }, */
            { text: "N.° DOCUMENTO DE IDENTIDAD", align: 'center', value: "numdoc_persona", class: 'secondary black--text' },
            { text: "APELLIDOS Y NOMBRES", align: 'center', value: "nom_alumno", class: 'secondary black--text' },
            { text: "FECHA DE NACIMIENTO", align: 'center', value: "fecnac_persona", class: 'secondary black--text' },
            { text: "SEXO", align: 'center', value: "sexo", class: 'secondary black--text' },
            { text: "AGREGAR", align: "center", value: "data-table-select", sortable: false, class: 'secondary black--text' }
        ],
        alumnosSeleccionados: [],
        ///////////////////////////



        //  modal confirmacion para agregar alumnos
        modal_confirm: false,
        ///////////////////////////



        AlumnosSeccion: {
            id: 0,
            id_colegio: sessionStorage.id_colegio,
            id_seccion: 0,
            id_persona: [],
            id_usuario: sessionStorage.id,
            id_ano_lectivo: sessionStorage.id_ano_lectivo
        },

        DefaultAlumnosSeccion: {
            id: 0,
            id_colegio: sessionStorage.id_colegio,
            id_seccion: 0,
            id_persona: [],
            id_usuario: sessionStorage.id,
            id_ano_lectivo: sessionStorage.id_ano_lectivo
        },

        defaultSeccion: {
            id_usuario: sessionStorage.id,
            id_nivel: 0,
            id_grado: 0,
            id_ano_lectivo: sessionStorage.id_ano_lectivo,
            id_turno: 0,
            estado_seccion: 0,
            min_capacidad: 0,
            max_capacidad: 0,
            id_colegio: sessionStorage.id_colegio
        },

        parametros: {
            id_colegio: sessionStorage.id_colegio,
            id_seccion: 0,
            id_ano_lectivo: sessionStorage.id_ano_lectivo,
        },

        nivelParams: {
            id_ano_lectivo: sessionStorage.id_ano_lectivo,
            id_colegio_adm_nivel: sessionStorage.id_colegio
        },
    }),



    computed: {

        validationRules() {
            return validationRules; // Importa y utiliza las reglas desde el archivo validatorHelpers.js
        },

        formAccion() {
            return this.editando === -1 ? 'Crear' : 'Editar '
        },



        ...mapGetters('login', ['componenteEvento'])
    },


    created() {
        this.actualizarParamentro()
    },


    mounted() {
        this.getAllNivelesAdmin();
        this.getAllTurnos();
    },

    watch: {
        modal_alumnos(e) {
            if (!e) {
                this.alumnosSeleccionados = [];
            }
        },        
    },

    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        ////////////////////////////////////////////////////////
        // setAbreviatura(){            
        //     const palabras = this.editedSeccion.nombre_seccion.match(/\b\w(?=\s|$)/g);
        //     this.editedSeccion.abreviatura_seccion = palabras.map(letra => letra.toUpperCase()).join('');
        // },
        //---------traer turnos-----------------
        async getAllTurnos() {
            try {
                let response = await axios.get("/mantenimiento/turnos/");
                this.Turnos = response.data;
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },



        //-------traer mis niveles de administracion-------
        async getAllNivelesAdmin() {
            let params = this.nivelParams
            try {
                let response = await axios.post("/administrativo/nivel/niveladmin/", params);
                this.NivelesAdmin = response.data;
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },




        //---------traer mis grados de administracion
        // --21/03/2020. Robert, Se modifica la vista del api para listar el id del nivel en adm_niveles.
        async getAllGradosAdmin(nivel) {
            this.defaultSeccion.id_nivel = nivel.id_nivel_adm_nivel
            this.titulo_nivel = nivel
            let params = this.defaultSeccion

            try {
                let response = await axios.post("/administrativo/grado/gradosNivelAdmin/", params);
                this.GradosAdmin = response.data;

                this.defaultSeccion.id_nivel = 0

                if (this.GradosAdmin.length === 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: 'Aún no hay "grados" registrados en este "nivel"', tiempo: null })
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                ///console.log(error);
            }
        },




        //-----------ver secciones --------------
        async verSecciones(item) {
            this.modal_secciones = true
            this.mostrarMensaje = false

            this.defaultSeccion.id_grado = item.id
            let params = this.defaultSeccion
            this.itemGrado = Object.assign({}, item)
            //console.log('X--itemGrado------>'+JSON.stringify(this.itemGrado))

            try {
                let response = await axios.post("/administrativo/seccion/seccionGrado/", params)
                this.SeccionGrado = response.data
                this.defaultSeccion.id_grado = 0

                if (this.SeccionGrado.length === 0) {
                    this.mostrarMensaje = true
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },


        async limpiarForm() {
            this.editedSeccion = {
                id_usuario: this.datoLogin.id, id_nivel: 0, id_grado: 0,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo, id_turno: 0,
                estado_seccion: 0, min_capacidad: '', max_capacidad: '', id_colegio: this.datoLogin.id_colegio
            }

            this.resetValidation()
        },


        resetValidation() {
            this.$refs.formDatos.resetValidation()
        },



        //-----------añadir datos al modal crear seccion--------------
        crearSecciones(itemGrado) {
            this.limpiarForm()
            this.editedSeccion.id_grado = itemGrado.id;
            this.editedSeccion.id_nivel = itemGrado.adm_nivel_id; // 21-03-2020. Se vincula con el id de adm_niveles
            this.modal_seccion = true;
            this.crearSec = true;
            this.editarSec = false;
            this.editando = -1
        },


        //-------------crear seccion nueva ----------------
        async addSeccion() {
            if (this.$refs.formDatos.validate()) {
                let params = this.editedSeccion;

                try {
                    await axios.post("/administrativo/seccion", params);
                    this.verSeccion(this.editedSeccion.id_grado);
                    this.modal_seccion = false;
                    this.crearSec = false
                    this.limpiarForm()

                    this.setEnviarMens({ tipo: "S", mensaje: `¡Información creada con éxito!`, tiempo: null })
                }

                catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                    //console.log(error);
                }
            }
        },

        OndeleteSeccionItem(item) {
            this.confirm.item = item
            this.confirm.title = "¿Está seguro de eliminar esta sección?";
            this.confirm.active = true;
        },

        async deleteSeccionItem() {
            // console.log('Eliminar seccion', this.confirm.item);
            try {
                await axios.delete("/administrativo/seccion/" + this.confirm.item.id)
                // this.verAlumnosSeccion(this.confirm.item);
                // console.log('Seccion ', this.editedSeccion.id_grado);

                this.verSeccion(this.confirm.item.id_grado);
                this.setEnviarMens({ tipo: "S", mensaje: "¡Información eliminada con éxito!", tiempo: null })
                this.clear_confirm()
            }
            catch (e) {

                this.setEnviarMens({ tipo: "E", mensaje: `Acción no realizada , asegurese de que la sección no tenga ningun alumno antes de eliminarla`, tiempo: null })

            }

        },

        editedItem(item) {
            this.crearSec = false
            this.editarSec = true
            this.modal_seccion = true
            this.editedSeccion = Object.assign({}, item);
            this.editando = item.length
        },
        async updateSeccion(id) {
            if (this.$refs.formDatos.validate()) {
                let params = this.editedSeccion;
                try {
                    await axios.put('/administrativo/seccion/' + id, params)
                    this.verSeccion(this.editedSeccion.id_grado);
                    this.modal_seccion = false;
                    this.crearSec = false
                    this.limpiarForm()
                    this.setEnviarMens({ tipo: "S", mensaje: `¡Información editada con éxito!`, tiempo: null })

                } catch (error) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                    //console.log(error);
                }
            }
        },

        //-----------ver secciones AL CREAR SECCION NUEVA --------------
        async verSeccion(id) {
            this.mostrarMensaje = false
            this.defaultSeccion.id_grado = id
            let params = this.defaultSeccion

            try {
                let response = await axios.post("/administrativo/seccion/seccionGrado/", params)
                this.SeccionGrado = response.data
                this.defaultSeccion.id_grado = 0

                if (this.SeccionGrado.length === 0) {
                    this.mostrarMensaje = true
                }
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },

        //-----------ver secciones --------------
        async verAlumnosSeccion(item) {
            this.modal_seccion_alumnos = true
            this.mostrarMensaje2 = false

            this.parametros.id_seccion = item.id;
            let params = this.parametros
            // this.itemSeccion = Object.assign({}, item);

            try {
                let response = await axios.post("/administrativo/seccion/secalu/fil/", params);
                this.SeccionAlumnos = response.data;

                if (this.SeccionAlumnos.length === 0) {
                    this.mostrarMensaje2 = true
                }
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },




        //---------traer Alumnos-----------------
        async getAllAlumnos(item) {

            this.Alumnos = [];
            this.modal_alumnos = true;

            this.AlumnosSeccion.id_seccion = item.id;
            var id = item.id_colegio
            let id_ano_lectivo = this.datoLogin.id_ano_lectivo;
            try {
                let response = await axios.get("/administrativo/alumno/filalum/" + id + "/alectivo/" + id_ano_lectivo + "/?id_grado=" + item.id_grado);
                this.Alumnos = response.data;
                //console.log('aquiiiii' ,this.Alumnos);
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },



        //-------------crear alumnos a seccion ----------------
        async addAlumnosSeccion() {
            this.modal_confirm = false;

            this.AlumnosSeccion.id_persona = this.alumnosSeleccionados.map(alumno => alumno.id);
            let params = this.AlumnosSeccion;

            let seccion = this.SeccionGrado.find(sec => sec.id == this.parametros.id_seccion)
            console.log(seccion,'antes');
            // if (this.AlumnosSeccion.id_persona > seccion.max_capacidad || this.AlumnosSeccion.id_persona < min_capacidad) {
            //     this.setEnviarMens({ tipo: "W", mensaje: "La canti", tiempo: null })
            // }
            //console.log(this.AlumnosSeccion);
            // console.log('despues');

            try {
                const response = await axios.post("/administrativo/alumnosSeccion", params);
                if(response.data.tooManyStudents){
                    this.setEnviarMens({ tipo: "W", mensaje: response.data.message, tiempo: null })
                }
                // this.AlumnosSeccion = {
                //     id: 0,
                //     id_colegio :  this.datoLogin.id_colegio,
                //     id_seccion :  0,
                //     id_persona :  [],
                //     id_usuario :  this.datoLogin.id,
                //     id_ano_lectivo : this.datoLogin.id_ano_lectivo
                // }
                // this.DefaultAlumnosSeccion = {
                //     id: 0,
                //     id_colegio: this.datoLogin.id_colegio,
                //     id_seccion: 0,
                //     id_persona: [],
                //     id_usuario: this.datoLogin.id,
                //     id_ano_lectivo:this.datoLogin.id_ano_lectivo
                // },
                this.modal_alumnos = false;
                this.editedSeccion = Object.assign({}, this.defaultSeccion);
                this.AlumnosSeccion = Object.assign({}, this.DefaultAlumnosSeccion);
                // console.log('alumnos dentro de la seccion', this.AlumnosSeccion)


            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                //console.log(error);
            }
        },

        clear_confirm() {
            this.confirm.item = {};
            this.confirm.title = "";
            this.confirm.active = false;
        },
        //-- 23-05-2020. LUIS ROJAS.
        //-- METODO QUE PERMITE ELIMINAR UN ALUMNO
        //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
        OndeleteItem(item) {
            this.confirm.item = item
            this.confirm.title = "¿Está seguro de eliminar este registro?";
            this.confirm.active = true;
        },
        async deleteItem() {
            try {
                console.log(this.confirm.item, "gaaaaw");
                await axios.delete("/administrativo/alumnosSeccion/" + this.confirm.item.id_seccion_alumno)
                this.confirm.item.id = this.confirm.item.id_seccion
                this.verAlumnosSeccion(this.confirm.item);
                this.setEnviarMens({ tipo: "S", mensaje: "¡Información eliminada con éxito!", tiempo: null })
                this.clear_confirm()
            }
            catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },
        // filterKey(event) {
        //     // Si el código es menor que 48 (0) o mayor que 57 (9)
        //     if (event.keyCode == 69 || event.keyCode == 190 || event.keyCode == 189 || event.keyCode == 187) {
        //         //  // No se agrega
        //         //  if(event.keyCode != 8){
        //         event.preventDefault();
        //         //  }
        //     }
        // },

        // checaValor(item) {
        //     // Obtener valor actual
        //     let valor = parseInt(item.value);
        //     // Si no es número o es menor de 1
        //     if (isNaN(valor) || valor < 1) {
        //         // Asignar 1
        //         item.value = 1;
        //     }
        // },


        // CUSTOM SEARCH PARA LA TABLA
        multiColumnFilter(value, search, item) {

            const name = item.nombre_persona || "";
            const ap1 = item.ape1_persona || "";
            const ape2 = item.ape2_persona || "";
            const numdoc = item.numdoc_persona || "";

            return (
                name.toLowerCase().includes(search.toLowerCase()) ||
                numdoc.toLowerCase().includes(search.toLowerCase()) ||
                ap1.toLowerCase().includes(search.toLowerCase()) ||
                ape2.toLowerCase().includes(search.toLowerCase())
            );
        }


    }
};
</script>
<style  scoped>
.text-nombre {
    text-transform: uppercase;
}

#container {
    margin-bottom: 100px;
}
</style>